(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["vanto-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const videos = document.querySelectorAll('[data-hero-video]');
    const mobileViewport = window.matchMedia('(max-width: 749px)');

    const isActiveVideo = (video) => mobileViewport.matches
      ? video.classList.contains('hero__video--mobile')
      : video.classList.contains('hero__video--desktop');

    const loadVideo = (video) => {
      if (video.dataset.loaded || reducedMotion.matches || !isActiveVideo(video)) return;
      video.dataset.loaded = 'true';
      video.querySelectorAll('source[data-src]').forEach((source) => {
        source.src = source.dataset.src;
        source.removeAttribute('data-src');
      });
      video.load();
      video.play().catch(() => {});
    };

    const loadActiveVideo = () => videos.forEach((video) => {
      if (isActiveVideo(video)) loadVideo(video);
      else video.pause();
    });

    const scheduleMobileVideo = () => {
      const start = () => {
        window.setTimeout(() => {
          if ('requestIdleCallback' in window) window.requestIdleCallback(loadActiveVideo, { timeout:2000 });
          else loadActiveVideo();
        }, 3500);
      };
      if (document.readyState === 'complete') start();
      else window.addEventListener('load', start, { once:true });
    };

    videos.forEach((video) => {
      video.addEventListener('loadeddata', () => video.classList.add('is-ready'), { once:true });
      video.addEventListener('error', () => { video.hidden = true; });
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(([entry]) => {
          if (reducedMotion.matches || !video.dataset.loaded) return;
          if (entry.intersectionRatio > 0.25) video.play().catch(() => {});
          else video.pause();
        }, { threshold:[0,0.25] });
        observer.observe(video.closest('.hero'));
      }
    });

    if (!reducedMotion.matches) {
      if (mobileViewport.matches) scheduleMobileVideo();
      else loadActiveVideo();
    }

    const handleMotionPreference = (event) => {
      if (event.matches) videos.forEach((video) => { video.pause(); video.classList.remove('is-ready'); });
      else if (mobileViewport.matches) scheduleMobileVideo();
      else loadActiveVideo();
    };
    const handleViewportChange = () => {
      videos.forEach((video) => { if (!isActiveVideo(video)) video.pause(); });
      if (!reducedMotion.matches) {
        if (mobileViewport.matches) scheduleMobileVideo();
        else loadActiveVideo();
      }
    };
    if (reducedMotion.addEventListener) reducedMotion.addEventListener('change', handleMotionPreference);
    else reducedMotion.addListener(handleMotionPreference);
    if (mobileViewport.addEventListener) mobileViewport.addEventListener('change', handleViewportChange);
    else mobileViewport.addListener(handleViewportChange);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vanto-lookbook-editorial"] && !Shopify.designMode) return;
  try {
    
  (()=>{if(matchMedia('(prefers-reduced-motion: reduce)').matches)return;document.querySelectorAll('[data-editorial-video]').forEach(video=>{if(!('IntersectionObserver'in window))return;const observer=new IntersectionObserver(([entry])=>{if(entry.isIntersecting){video.preload='metadata';video.play().catch(()=>{});}else video.pause();},{rootMargin:'240px 0px',threshold:.15});observer.observe(video);});})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vanto-mens-film"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-mens-film]').forEach((section) => {
      const video = section.querySelector('[data-mens-film-video]');
      if (!video || window.matchMedia('(min-width: 750px)').matches || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      const source = video.querySelector('source[data-src]');
      let loaded = false;
      const loadVideo = () => {
        if (loaded || !source) return;
        source.src = source.dataset.src;
        source.removeAttribute('data-src');
        video.load();
        loaded = true;
      };
      video.addEventListener('canplay', () => video.classList.add('is-ready'), { once:true });
      video.addEventListener('error', () => { video.hidden = true; });
      if (!('IntersectionObserver' in window)) { loadVideo(); return; }
      const preloadObserver = new IntersectionObserver(([entry]) => {
        if (entry.isIntersecting) { loadVideo(); preloadObserver.disconnect(); }
      }, { rootMargin:'160px 0px' });
      const playbackObserver = new IntersectionObserver(([entry]) => {
        if (entry.intersectionRatio >= 0.35) {
          loadVideo();
          video.play().catch(() => {});
        } else {
          video.pause();
        }
      }, { threshold:[0,0.35,0.75] });
      preloadObserver.observe(section);
      playbackObserver.observe(section);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vanto-product-recommendations"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-recommendations')) {
    customElements.define('product-recommendations', class ProductRecommendations extends HTMLElement {
      connectedCallback() {
        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          });
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
